import { render, staticRenderFns } from "./bannerInformation.vue?vue&type=template&id=521dc42a"
import script from "./bannerInformation.vue?vue&type=script&lang=js"
export * from "./bannerInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports